import { render, staticRenderFns } from "./NotAllow.vue?vue&type=template&id=3aa1644a&scoped=true&"
import script from "./NotAllow.vue?vue&type=script&lang=js&"
export * from "./NotAllow.vue?vue&type=script&lang=js&"
import style0 from "./NotAllow.vue?vue&type=style&index=0&id=3aa1644a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa1644a",
  null
  
)

export default component.exports